// Suppress React defaultProps deprecation warnings from third-party libraries
// These warnings come from Kendo React v5.x components and will be fixed in Kendo v6.x
// This is a temporary measure to keep the console clean during development
// Related warnings suppressed:
// - All KendoReact* components with defaultProps
// - CurrentTimeMarker, MonthView, RecurrenceEditor, MultiDayView, etc.
// - Reactstrap Popover defaultProps and prop validation
//
// Note: Cookiebot CSP warnings appear in development but are allowed in production CSP (Program.cs)

const originalWarn = console.warn;
const originalError = console.error;

console.warn = function filterWarnings(...args) {
  const msg = String(args[0] || '');
  
  // Filter out specific warnings we can't control from third-party libraries
  if (msg) {
    // Suppress all Kendo React v5.x and reactstrap defaultProps warnings
    if (msg.includes('Support for defaultProps will be removed')) {
      return;
    }
    
    // Suppress React Router future flag warnings (already implemented)
    if (msg.includes('React Router Future Flag Warning')) {
      return;
    }
    
    // Suppress ALL prop type validation warnings
    if (msg.includes('Failed prop type')) {
      return;
    }
  }
  
  // Pass through all other warnings (important for catching real issues)
  originalWarn.apply(console, args);
};

console.error = function filterErrors(...args) {
  const msg = String(args[0] || '');
  
  // Filter out warnings that React Development mode sends via console.error
  if (msg) {
    // Suppress all Kendo React v5.x and reactstrap defaultProps warnings
    // React Dev mode sends these as console.error
    if (msg.includes('Support for defaultProps will be removed')) {
      return;
    }
    
    // Suppress ALL prop type validation errors (most are from third-party libs)
    // This includes: transition.timeout, Fade timeout, PopperContent, etc.
    if (msg.includes('Failed prop type') || msg.includes('prop type')) {
      return;
    }
    
    // Suppress Cookiebot CSP violations in development (allowed in production)
    if (msg.includes('cookiebot') || msg.includes('Content Security Policy')) {
      return;
    }
  }
  
  // Pass through all other errors
  originalError.apply(console, args);
};

// Export to make this a module (required by TypeScript --isolatedModules)
export {};
